<script>
  import Multiselect from 'vue-multiselect'
  import {
    categoryMethods,
  } from '@state/helpers'

  export default {
    components: {
      Multiselect,
    },
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      value: {
        type: null,
        required: true,
      },
      errors: {
        type: null,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      disabled: {
        type: Boolean,
        required: false,
      },
      mandatory: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        cat1: null,
        cat2: null,
        cat3: null,
        isLoading: false,
        secondaryCategories: [],
        tertiaryCategories: [],
      }
    },
    watch: {
      async cat1 (val) {
        if (!val) {
          this.cat2 = null
          this.secondaryCategories = []
          this.cat3 = null
          this.tertiaryCategories = []
        } else {
          const { data } = await this.tryToGetCategoryChildrens(val, '')
          this.secondaryCategories = data.data
        }
        this.setValue()
      },
      async cat2 (val) {
        if (!val) {
          this.cat3 = null
          this.tertiaryCategories = []
        } else {
          const { data } = await this.tryToGetCategoryChildrens(val, '')
          this.tertiaryCategories = data.data
        }
        this.setValue()
      },
      cat3 (val) {
        this.setValue()
      },
    },
    async created() {
      if (!this.value) {
        return
      }
      let category = this.value
      while (category) {
        this[`cat${category.level}`] = category
        category = category.parent
      }
    },
    methods: {
      ...categoryMethods,
      selectCategory (category) {
        if (!category) {
          return
        }
        this.cat2 = null
        this.secondaryCategories = category.children
        this.cat3 = null
        this.tertiaryCategories = []
      },
      selectSecondaryCategory (category) {
        if (!category) {
          return
        }
        this.cat3 = null
        this.tertiaryCategories = category.children
      },
      setValue () {
        if (this.cat3) {
          return this.$emit('change', {
            ...this.cat3,
            level: 3,
            parent: {
              ...this.cat2,
              level: 2,
              parent: {
                ...this.cat1,
                level: 1,
              }
            }
          })
        }
        if (this.cat2) {
          return this.$emit('change', {
            ...this.cat2,
            level: 2,
            parent: {
              ...this.cat1,
              level: 1,
            }
          })
        }
        if (this.cat1) {
          return this.$emit('change', {
            ...this.cat1,
            level: 1,
          })
        }
        this.$emit('change', null)
      },
      tryToGetCategoryChildrens (category, search) {
        return this.getListCategories({
          search: `parent_id:${category.id};name:${search}`,
          fields: 'id,name',
          type: this.type,
          searchJoin: 'and',
          skipOnlyParent: 1,
        })
      },
      async tryToSearchSecondaryCategory (query = '') {
        const { data } = await this.tryToGetCategoryChildrens(this.cat1, query)
        this.secondaryCategories = data.data
      },
      async tryToSearchTertiaryCategories (query = '') {
        const { data } = await this.tryToGetCategoryChildrens(this.cat2, query)
        this.tertiaryCategories = data.data
      },
    },
  }
</script>

<template>
  <div>
    <div :class="['form-group tw-mb-2', { 'is-invalid': errors.category_id, 'mg-b-u': (!secondaryCategories || secondaryCategories && !secondaryCategories.length) && !cat2 }]">
      <label class="label-control">Category{{ mandatory ? '*' : '' }}</label>
      <FabricSelect
        v-model="cat1"
        class="bind-width"
        :get-data="params => getListCategories({
          ...params,
          fields: 'id,name',
          type: type,
          skipOnlyParent: 0,
        })"
        :disabled="disabled"
        @change="selectCategory"
      />
      <p v-if="errors && errors.category_id" class="text-danger">{{ errors.category_id }}</p>
    </div>
    <div v-if="cat1 && secondaryCategories && secondaryCategories.length > 0 && (cat2 || !disabled)" :class="['form-group tw-mb-2', { 'mg-b-u': (!tertiaryCategories || tertiaryCategories && !tertiaryCategories.length) && !cat3 }]">
      <label class="label-control">Secondary Category</label>
      <Multiselect
        v-model="cat2"
        class="bind-width"
        :multiple="false"
        :class="{
          'scrollable': secondaryCategories.length > 7,
        }"
        :options="secondaryCategories"
        :internal-search="false"
        :disabled="disabled"
        label="name"
        track-by="id"
        @search-change="tryToSearchSecondaryCategory"
        @select="selectSecondaryCategory"
      />
    </div>
    <div v-if="cat2 && tertiaryCategories && tertiaryCategories.length > 0 && (cat3 || !disabled)" :class="['form-group mg-b-u']">
      <label class="label-control">Tertiary Category</label>
      <Multiselect
        v-model="cat3"
        class="bind-width"
        :multiple="false"
        :class="{
          'scrollable': tertiaryCategories.length > 7,
        }"
        :options="tertiaryCategories"
        :internal-search="false"
        :disabled="disabled"
        label="name"
        track-by="id"
        @search-change="tryToSearchTertiaryCategories"
      />
    </div>
  </div>
</template>
